var $ = window.$;
var jQuery = window.$;
(function() {
  'use strict';

  function _positionHotspots(options) {

    $(options.selector).each(function() {
      var xPos = $(this).data('x');
      var yPos = $(this).data('y');

      $(this).css({
        'top': 'calc('+yPos+'% - 12.5px)',
        'left': 'calc('+xPos+'% - 12.5px)',
        'display': 'block',
      });
      $(this).children(options.tooltipselector).css({
        'margin-left': - ($(this).children(options.tooltipselector).width() / 2)
      });
    });
  }

  function _bindHotspots(e, options) {
    try
    {
      if ($(e).children(options.tooltipselector).is(':visible'))
      {
        $(e).children(options.tooltipselector).css('display', 'none');
      }
      else
      {
        $(options.selector + ' ' + options.tooltipselector).css('display', 'none');
        $(e).children(options.tooltipselector).css('display', 'block');
        if ($(window).width() - ($(e).children(options.tooltipselector).offset().left + $(e).children(options.tooltipselector).outerWidth()) < 0)
        {
          $(e).children(options.tooltipselector).css({
            'right': '0',
            'left': 'auto',
          });
        }
      }
    }
    catch (e)
    {
      console.log(e)
    }
  }

  $.fn.hotSpot = function( options ) {
    var _options = $.extend( {}, $.fn.hotSpot.defaults, options );

    this.each(function() {
      _positionHotspots.call($(this), _options);
    });

    $(window).resize(function() {
      this.each(function() {
        _positionHotspots.call($(this), _options);
      });
    }.bind(this));

    switch (_options.bindselector) {
      case 'click':
        $(_options.selector).bind ('click', function(e){_bindHotspots(e.currentTarget, _options)});
        break;
      case 'hover':
        $(_options.selector).hover (function(e){_bindHotspots(e.currentTarget, _options)});
        break;
      default:
        break;
    }

    return this;
  };

  $.fn.hotSpot.defaults = {
    mainselector: '#hotspotImg',
    selector: '.hot-spot',
    imageselector: '.img-responsive',
    tooltipselector: '.tooltip',
    bindselector: 'hover'
  };
}(jQuery));
